import dataLayer from '../../../assets/scripts/helpers/data-layer';
import * as focusModuleTrap from 'focus-trap';
// const createFocusTrap = require( 'focus-trap' ); // https://github.com/davidtheclark/focus-trap/issues/30

const $body = $('body');
const $element = $('.feedback-form');
const $button = $('.feedback-button');
const $feedbackAdditional = $('.feedback-form__additional');
const $openFeedbackButton = $('.js-feedback-button--open');
const $closeFeedbackButton = $('.js-feedback-button--close');
const $selectRating = $('.feedback-form__rating-button');
const $feedbackThankYou = $('.feedback-form__thank-you');
const $feedbackComment = $('.feedback-form__comment');
const $feedbackPageId = $('.feedback-form__pageid');
const $feedbackLang = $('.feedback-form__lang');
const $feedbackId = $('.feedback-form__id');
const $sendFeedback = $('.js-send-feedback');
const $receivedFeedback = $('.feedback-form__received');
const $feedbackBackground = $('.feedback-form__background');
let ratingValueName = '';
let ratingValue = '';

const focusTrap = focusModuleTrap.createFocusTrap('.feedback-form');

const openFeedbackForm = () => {
	$element.toggleClass('feedback-form--visible');
	$element.removeClass('feedback-form--hidden');
	$body.addClass('scroll-lock');
	$element.attr('aria-hidden', 'false');
	$openFeedbackButton.attr('aria-expanded', 'true');
	focusTrap.activate();
};

const closeFeedbackForm = () => {
	$element.toggleClass('feedback-form--hidden');
	$element.removeClass('feedback-form--visible');
	$body.removeClass('scroll-lock');
	$element.attr('aria-hidden', 'true');
	$openFeedbackButton.attr('aria-expanded', 'false');
	$feedbackComment.val('');
	focusTrap.deactivate();
};

const openAndSelectRating = (event) => {
	$feedbackAdditional.removeClass('feedback-form__additional--hidden');
	$selectRating.removeClass('feedback-form__rating-button--selected');
	$feedbackThankYou.addClass('feedback-form__thank-you--visible');
	$(event.currentTarget).addClass('feedback-form__rating-button--selected');
	$feedbackAdditional[0].style.maxHeight = $feedbackAdditional[0].scrollHeight + 60 + 'px';
	ratingValue = event.currentTarget.value;
	ratingValueName = $(event.currentTarget).attr('data-interaction');
	dataLayer.register('interaction', ratingValueName);
};

const sendFeedback = (event) => {
	const commentValue = $feedbackComment.val();
	const pageid = $feedbackPageId.val();
	const id = $feedbackId.val();
	const lang = $feedbackLang.val();

	const feedbackData = {
		'rating': ratingValue,
		'comment': commentValue,
		'pageid': pageid,
		'id': id,
		'lang': lang
	};

	$.ajax({
		type: 'POST',
		url: '/_feedback/save',
		data: JSON.stringify(feedbackData),
		contentType: 'application/json; charset=utf-8',
		dataType: 'json',
		success: function (data) {
			$feedbackId.val(data);
			dataLayer.register('interactionLabel', "smiley-click");

			if ($(event.target).hasClass('js-send-feedback')) {
				$receivedFeedback.addClass('feedback-form__received--visible');
				dataLayer.register('interaction', ratingValueName)
				dataLayer.register('interactionLabel', $feedbackComment.val());
				$feedbackComment.val('').attr('disabled', 'disabled');
				$feedbackComment.addClass('hidden');
				event.target.disabled = true;
			}
			dataLayer.register('eventAction', 'feedback');
			window._satellite && window._satellite.track('action');
		},
		error: function (errorMsg) {
			console.log(errorMsg);
			/* remove later */
			dataLayer.register('interactionLabel', $feedbackComment.val());
			dataLayer.register('eventAction', 'feedback');
			window._satellite && window._satellite.track('action');
		},
		failure: function (failureMsg) {
			console.log(failureMsg);
		}
	});
};

const scroll = () => {
	if (window.pageYOffset > 200) {
		$button.addClass('feedback-button--visible');
	} else {
		$button.removeClass('feedback-button--visible');
	}
};

const eventScroll = () => {
	let waiting = false, endScrollHandle;
	$(window).scroll(function () {
		if (waiting) {
			return;
		}
		waiting = true;
		clearTimeout(endScrollHandle);
		scroll();
		setTimeout(function () {
			waiting = false;
		}, 100);
		endScrollHandle = setTimeout(function () {
			scroll();
		}, 200);
	});
};

const events = () => {
	$openFeedbackButton.on('click', openFeedbackForm);
	$closeFeedbackButton.on('click', closeFeedbackForm);
	$feedbackBackground.on('click', closeFeedbackForm);
	$selectRating.on('click', openAndSelectRating);
	$sendFeedback.on('click', sendFeedback);
	$selectRating.on('click', sendFeedback);
	eventScroll();
};

const init = () => {
	events();
};

export default init;
